/* eslint-disable import/no-named-as-default */
import React from 'react';
import PropTypes from 'prop-types';
import EquipmentSelect from 'equipmentComponents/EquipmentSelect';
import GponEquipmentSelect from 'equipmentComponents/GponEquipmentSelect';
import EquipmentSerialTextBox from 'equipmentComponents/EquipmentSerialTextBox';
import EquipmentHostIdTextBox from 'equipmentComponents/EquipmentHostIdTextBox';
import Scanner from 'equipmentComponents/Scanner';
import IconMenu from 'material-ui/IconMenu';
import MenuItem from 'material-ui/MenuItem';
import IconButton from 'material-ui/IconButton';
import MoreVertIcon from 'material-ui/svg-icons/navigation/more-vert';
import Divider from 'material-ui/Divider';
import EquipmentUtils from 'utils/EquipmentUtils';
import { hitActionRegistered } from 'utils/helper';
import { textUtils } from 'utils/textUtils';

class OutletMenu extends React.Component {

    constructor(props, context) {
        super(props, context);
        this.handleMenuAction = this
            .handleMenuAction
            .bind(this);
    }

    componentWillMount() {
        const { outlet, workOrderActions, orderId } = this.props;

        const isMoveTransfer = outlet.get('isTransferMove');

        if (isMoveTransfer) {
            workOrderActions.outletUpdate({
                orderId: orderId,
                newSerialNumber: outlet.get('macAddress'),
                outletId: outlet.get('equipmentOutlet')
            });
        }
    }

    handleMenuAction(e, value) {
        e.preventDefault();
        const { orderId, workOrderActions, outlet, equipmentHitDetails, refreshHitDetails } = this.props;

        switch (value) {
            case 'hit':
                if (hitActionRegistered(equipmentHitDetails, outlet)) {
                    return alert(textUtils.equipment.hit.hitFailed);
                }

                workOrderActions.equipmentHitStarted({
                    serialNumber: outlet.get('seriaNumber')
                }, orderId);
                break;
            case 'refreshHit':
                if (hitActionRegistered(refreshHitDetails, outlet)) {
                    return alert(textUtils.equipment.hit.hitFailed);
                }

                workOrderActions.equipmentRefreshHitStarted({
                    serialNumber: outlet.get('seriaNumber')
                }, orderId);
                break;
            case 'unpairPair':
                workOrderActions.unpairPairStarted({
                    billingSystem: "Icoms",
                    userId: '',
                    gatewaySerialNumber: outlet.get('seriaNumber'),
                    cableCardMacAddress: '',
                    cableCardSerialNumber: '',
                    cableCardId: '',
                    videoHostId: ''
                }, orderId);
                break;
            default:
                if (EquipmentUtils.isGponFiberModemType(outlet)) {
                    workOrderActions.outletUpdate({
                        orderId: orderId,
                        newModel: 'none',
                        outletId: outlet.get('equipmentOutlet')
                    });
                }
                workOrderActions.outletUpdate({
                    orderId: orderId,
                    serialEntryMethod: value,
                    outletId: outlet.get('equipmentOutlet')
                });
                break;
        }
    }


    render() {
        const {
            outlet,
            orderId,
            workOrderActions,
            techInventory,
            loading,
            equipmentValidations,
            customerDetails,
            houseEquipmentDetails
        } = this.props;

        let input = (<EquipmentSelect
            disabled={loading}
            outlet={outlet}
            workOrderActions={workOrderActions}
            orderId={orderId}
            techInventory={techInventory}
            customerDetails={customerDetails}
            houseEquipmentDetails={houseEquipmentDetails} />);

        if (outlet.get('serialEntryMethod') === 'manual') {
            input = EquipmentUtils.isToShowGponDropDown(outlet) ?
                (<GponEquipmentSelect
                    outlet={outlet}
                    workOrderActions={workOrderActions}
                    orderId={orderId}
                    equipmentValidations={equipmentValidations}
                    customerDetails={customerDetails}
                />) : (<EquipmentSerialTextBox
                    disabled={loading}
                    outlet={outlet}
                    workOrderActions={workOrderActions}
                    orderId={orderId}
                    techInventory={techInventory} />);
        }

        if (outlet.get('serialEntryMethod') === 'scanner') {
            input = (<Scanner outlet={outlet} workOrderActions={workOrderActions} orderId={orderId} />);
        }

        const button = (
            <IconButton disabled={loading}><MoreVertIcon /></IconButton>
        );

        const isMoveTransfer = outlet.get('isTransferMove');
        const disableAddsAndSwaps = outlet.get('disableAddsAndSwaps') ? outlet.get('disableAddsAndSwaps') : false;
        const menuItems = [];

        menuItems.push((<MenuItem key="header" primaryText="Modify Equipment" disabled={true} />));
        menuItems.push((<MenuItem
            disabled={loading || (isMoveTransfer) || disableAddsAndSwaps || EquipmentUtils.isCustomerOwnedModem(outlet)}
            key="inventory"
            value="select"
            primaryText="Choose From Inventory" />));

        menuItems.push((<MenuItem
            disabled={loading || disableAddsAndSwaps}
            key="manual"
            value="manual"
            primaryText="Type Manually" />));


        if (orderId.toLowerCase().startsWith('u') || orderId.toLowerCase().startsWith('c')) {
            if (EquipmentUtils.isHitable(outlet)) {
                menuItems.push((<Divider key="divider" />));
                if (outlet.get('isAddressableHitFlag')) {
                    menuItems.push((<MenuItem disabled={loading} key="hit" value="hit" primaryText="Send Addressable Hit" />));
                }
                if (outlet.get('isRefreshHitFlag')) {
                    menuItems.push((<MenuItem disabled={loading} key="refreshHit" value="refreshHit" primaryText="Send Refresh Hit" />));
                }
            }
        }
        else //icoms
        {
            if (EquipmentUtils.isHitable(outlet)) {
                menuItems.push((<Divider key="divider" />));
                menuItems.push((<MenuItem disabled={loading} key="hit" value="hit" primaryText="Send Addressable Hit" />));
                if (outlet.get('requiredPortType').indexOf('MATE') === -1) {
                    menuItems.push((<MenuItem disabled={loading} key="refreshHit" value="refreshHit" primaryText="Send Refresh Hit" />));
                }
            }
        }

        const gatewayModels = ['MG5000', 'DCX3635'];
        const outletModel = outlet.get('model');

        let modelIsGateway = false;
        if (outletModel) {
            modelIsGateway = gatewayModels.indexOf(outletModel) > -1;
        }

        if (modelIsGateway) {
            menuItems.push((<Divider key="unpairdivider" />));
            menuItems.push((<MenuItem disabled={loading} key="unpairPair" value="unpairPair" primaryText="Unpair / Pair" />));
        }

        let inputHostId = null;
        if (outlet.get('currentPortType') === "SADIGCARD") {
            inputHostId = (
                <div className="row">
                    <div className="col s10">
                        <EquipmentHostIdTextBox
                            disabled={false}
                            outlet={outlet}
                            workOrderActions={workOrderActions}
                            orderId={orderId}
                            techInventory={techInventory} />
                    </div>
                    <div className="col s2">&nbsp;</div>
                </div>
            );
        }

        return (
            <div>
                <div className="row">
                    <div className="col s10">
                        {input}</div>
                    <div className="col s2">
                        <IconMenu iconButtonElement={button} onChange={this.handleMenuAction}>
                            {menuItems}
                        </IconMenu>
                    </div>
                </div>
                {inputHostId}
            </div>
        );
    }
}

OutletMenu.propTypes = {
    outlet: PropTypes.object,
    orderId: PropTypes.string,
    techInventory: PropTypes.object,
    workOrderActions: PropTypes.object,
    loading: PropTypes.bool,
    billingSystem: PropTypes.string,
    isSkinnyInstallType: PropTypes.bool
};
export default OutletMenu;



// WEBPACK FOOTER //
// ./src/components/equipment/OutletMenu.js